export default __webpack_public_path__ + "0b2dc8c106bcc74947360a83426d3c07.png";